<template>
    <div>
        <b-card :border-variant="!disabled ? 'primary':'secondary'">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <h5 class="mb-0">Medidas de Emergencias / Plan Emergencia / Autoprotección Cliente</h5>
                <b-button v-if="!disabled && can('delete_gei_master_delivery_installation_client_ee')"
                    variant="outline-success"
                    @click="addRow"
                    :disabled="hasMatchingDocument"
                >
                    <feather-icon
                        icon="PlusIcon"
                        size="16"
                        variant="success"
                        class="cursor-pointer "

                    />
                </b-button>
            </div>

            <form-base-document
                :documents-state-data="documents_client_emergency"
                :documents-columns="columns"
                :documents-route="documents_by_route_client_emergency"
                :context="'client-emergency'"
                :is-disabled="disabled"
                :create-permission="can('create_gei_master_emergency_plan_client')"
                :delete-permission="can('delete_gei_master_emergency_plan_client')"
            />
        </b-card>

    </div>
</template>

<script>
import {BCard, BButton} from 'bootstrap-vue'
import {mapState} from "vuex"
import {createHelpers} from "vuex-map-fields"
import {Spanish as SpanishLocale} from 'flatpickr/dist/l10n/es'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import formBaseDocument
    from "@/views/gei/masters_installations/form/generalDataAndRisks/components/base/formBaseDocument"


const {mapFields} = createHelpers({
    getterType: 'masterInstallationDocuments/getField',
    mutationType: 'masterInstallationDocuments/updateField',
})

export default {
    name: "FormGeneralDocuments",
    components: {
        BButton,
        BCard,
        formBaseDocument
    },
    props: {
        disabled: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            SpanishLocale,
            columns: [
                {key: 'options', label: 'Acciones', sortable: false},
                {key: 'document_date', label: 'Fecha', sortable: false},
                {key: 'document_type_id', label: 'Tipo Documento', sortable: false},
                {key: 'observations', label: 'Observaciones', sortable: false},
            ],
        }
    },
    computed: {
        ...mapState('masterInstallation', ['master_installation']),
        ...mapState('masterInstallationDocuments', []),
        ...mapFields({
            documents_client_emergency: 'documents_client_emergency',
            documents_by_route_client_emergency: 'documents_by_route_client_emergency',
        }),
        hasMatchingDocument() {
          return this.documents_client_emergency.some(doc => doc.empty_row === true)
        }
    },
    mounted() {
        this.context = 'client-emergency'
        this.getDocumentTypes()
    },
    methods: {
        can(permission) {
            return this.$store.getters.can(permission)
        },
        addRow() {
            const newRow = {
                empty_row: true,
                document_date: null,
                document_type_id: null,
                route: this.master_installation.installation_code + '/MEDIDAS_EMERGENCIA/Cliente',
                observations: null,
                options: null,
                master_installation_id: this.master_installation.id,
            }

            this.documents_client_emergency.push(newRow)
            this.documents_client_emergency.editedRow = newRow
        },
        getDocumentTypes() {
            this.showLoading = true

            this.$store.dispatch('documentsTypes/getAllDocumentTypes')
            .then(response => {

                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
    }
}
</script>
